const defaultDates = [
  {
    from: {day: 1, month: 10},
    to: {day: 31, month: 12},
    defaultsTo: { month: 1, year: 1 }
  },
  {
    from: {day: 1, month: 1},
    to: {day: 31, month: 1},
    defaultsTo: { month: 1, year: 0 }
  },
  {
    from: {day: 1, month: 2},
    to: {day: 31, month: 9},
    defaultsTo: { month: 13, year: 0 } // 13 indicates next month
  }
];
const backDates = [{
    from: {day: 1, month: 1},
    to: {day: 30, month: 6},
    earliest: { month: 1, year: 0 }
  }, {
    from: {day: 1, month: 7},
    to: {day: 31, month: 12},
    earliest: { month: 7, year: 0 }
  }
];
const forwardDate = {month: 1, year: 5};

const CalendarDates = {
  todayDate: new Date(),

  getOptions() {
    // Generate Month Options
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const { earliest } = this.findPeriod(backDates);
    let monthOptions = [];
    for (let i = earliest.year; i <= forwardDate.year; i++) {
      const startMonth = (i === earliest.year) ? earliest.month - 1 : 0;
      const noOfMonths = (i === forwardDate.year) ? forwardDate.month : 12;

      for (let j = startMonth; j < noOfMonths; j++) {
        const date = new Date(this.todayDate.getFullYear() + i, j);
        monthOptions.push(
          {
            label: `${ monthNames[date.getMonth()]}, ${ date.getFullYear() }`,
            value: date.getTime()
          }
        );
      }
    }

    return monthOptions;
  },

  getDefaultValue() {
    // Get Default Starting Date
    const { defaultsTo: { year, month } } = this.findPeriod(defaultDates);
    const defaultMonth = month <= 12 ? month - 1 : this.todayDate.getMonth() + (month - 12);
    const defaultTimeStamp = (new Date(this.todayDate.getFullYear() + year, defaultMonth)).getTime();

    return this.getOptions().find((mO) =>
      mO.value === defaultTimeStamp
    );
  },
  findPeriod(periodsArray) {
    return periodsArray.find((period) => {
      return (
        (period.from.month - 1) <= CalendarDates.todayDate.getMonth() &&
        (period.from.day) <= CalendarDates.todayDate.getDate() &&
        (period.to.month - 1) >= CalendarDates.todayDate.getMonth() &&
        (period.to.day) >= CalendarDates.todayDate.getDate()
      );
    }) || periodsArray[0];
  }
}

export default CalendarDates;
